export const isEscapeKey = ({ keyCode }) => keyCode === 27;
export const isLeftKey = ({ keyCode }) => keyCode === 37;
export const isUpKey = ({ keyCode }) => keyCode === 38;
export const isRightKey = ({ keyCode }) => keyCode === 39;
export const isDownKey = ({ keyCode }) => keyCode === 40;
export const isTabKey = ({ keyCode }) => keyCode === 9;
export const isShiftTabKey = e => {
  return isTabKey(e) && e.shiftKey;
};
export const isEnterKey = ({ keyCode }) => keyCode === 13;
export const isCmdD = ({ key, metaKey }) => key === 'd' && metaKey;
